export default "__VITE_ASSET__mML5SP$q__"